import i18n from 'src/i18n'

export enum Routes {
  LOGIN = '/login',
  ESRI_CONFERENCE_REGISTRATION = '/esri-conference-registration',
  METEO = '/',
  MOSAIC = '/mosaic',
  INCENDIOS = '/incendios',
  SIMULADOR = '/simulador',
  BULLETINS = '/bulletins',
  REPORT = '/report',
  INFORME = '/informe',
  CONTAMINACION = '/pollution',
  COMPARAR = '/compare',
  RESTABLECER_PASSWORD = '/forgottenPassword',
  NEWS_AND_ADVICE = '/newsAndAdvice'
}

export const AppRoutes = {
  LOGIN: {
    id: Routes.LOGIN,
    name: i18n.t('routes.login')
  },

  METEO: {
    id: Routes.METEO,
    name: i18n.t('routes.meteo')
  },

  INCENDIOS: {
    id: Routes.INCENDIOS,
    name: i18n.t('routes.incendios')
  },

  REPORTS: {
    id: Routes.BULLETINS,
    name: i18n.t('header.reports')
  }
}

AppRoutes.LOGIN
